/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchOpenApiKeyResponseItem } from './search-open-api-key-response-item';


export interface SearchOpenApiKeyResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchOpenApiKeyResponseItem> | null;
}

